/* CartDrawer shim - delegates to custom cart drawer */
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    var cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', function(event) {
      event.preventDefault();
      if (window.openCartDrawer) window.openCartDrawer();
    });
  }
  open() { if (window.openCartDrawer) window.openCartDrawer(); }
  close() { if (window.closeCartDrawer) window.closeCartDrawer(); }
  renderContents(parsedState) {
    if (window.openCartDrawer) window.openCartDrawer();
  }
  getSectionsToRender() { return []; }
  getSectionInnerHTML() { return ''; }
  getSectionDOM() { return null; }
  setActiveElement(element) { this.activeElement = element; }
  setSummaryAccessibility() {}
}
customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends HTMLElement {
  constructor() { super(); }
  getSectionsToRender() { return []; }
  updateQuantity() {}
  onChange() {}
  onCartUpdate() {}
}
if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartDrawerItems);
}
